/** @format */
import { ImageWithFallback } from '@mpb-com/feather/components/atoms/image-with-fallback';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';

import CameraSVG from '@toucan/client/global/icons/camera.svg';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { fallbackImagePath } from '@toucan/client/global/product';

import { Link } from '@toucan/client/shared/components/link';

import { CarouselModal } from '@toucan/client/blocks/components/carousel';

import { ProductDetailsListItem } from '../product-details-list-item';
import { getSupportingImagesUrls } from './helpers';
import { ProductSupportingImagesListItemProps } from './types';

export const DEFAULT_TEST_ID = 'product-supporting-images-list-item';

export const ProductSupportingImagesListItem: FunctionComponent<
    ProductSupportingImagesListItemProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    supportingImages,
    ...otherProps
}: ProductSupportingImagesListItemProps) => {
    const { t } = useTranslation();
    const { setModalContent, setModalVisible } = useContext(ApplicationContext);

    const supportingImagesUrls = getSupportingImagesUrls(supportingImages);

    const handleSeeAdditionalPhotos = () => {
        setModalContent(
            <CarouselModal
                data-testid={`${dataTestId}__supporting-images-carousel`}
                items={supportingImagesUrls.map((url) => (
                    <ImageWithFallback
                        key={url}
                        src={url}
                        fallbackSrc={fallbackImagePath}
                    />
                ))}
                paginationItems={supportingImagesUrls.map((url) => ({
                    image: (
                        <ImageWithFallback
                            key={url}
                            src={url}
                            fallbackSrc={fallbackImagePath}
                        />
                    ),
                }))}
            />
        );
        setModalVisible(true, { size: ModalSize.FULLSCREEN });
    };

    return (
        <ProductDetailsListItem
            {...otherProps}
            data-testid={dataTestId}
            icon={<CameraSVG />}
            title={
                <Link
                    data-testid={`${dataTestId}__see-additional-photos-button`}
                    onClick={handleSeeAdditionalPhotos}
                >
                    {t('See additional photos')}
                </Link>
            }
        />
    );
};
